import React, { useEffect, useState } from "react";
import { Sparkles, Clock, MapPin, HeartHandshake, X } from "lucide-react";
import api from "../lib/api";

export const FirstTimerWelcomeCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/portal/first-timer-welcome").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d?.show) return null;
  const dismiss = () => { setD(null); api.post("/portal/first-timer-welcome/dismiss").catch(() => {}); };
  return (
    <div data-testid="first-timer-welcome-card" className="relative rounded-2xl border p-6 sm:p-7 overflow-hidden" style={{ background: "#FEF6D8", borderColor: "#F3DE8A" }}>
      <button data-testid="first-timer-welcome-dismiss" onClick={dismiss} aria-label="Dismiss welcome" className="absolute top-3 right-3 h-8 w-8 rounded-full flex items-center justify-center hover:bg-black/5" style={{ color: "#8a6a00" }}><X className="h-4 w-4" /></button>
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold" style={{ color: "#8a6a00" }}><Sparkles className="h-4 w-4" /> Welcome to {d.church}</div>
      <h2 className="font-head text-2xl font-extrabold mt-2 pr-8" style={{ color: "#3d3000" }} data-testid="first-timer-welcome-title">So glad you visited, {d.first_name || "friend"}!</h2>
      <p className="text-sm mt-1.5 max-w-xl" style={{ color: "#5c4a00" }}>It was a joy to have you with us. We'd love to see you again — here's everything you need for your next visit.</p>
      <div className="grid sm:grid-cols-3 gap-3 mt-5">
        <Info icon={Clock} label="Service times" value={d.service_times} testid="first-timer-welcome-times" />
        <Info icon={MapPin} label="Where we meet" value={d.address} testid="first-timer-welcome-address" />
        <Info icon={HeartHandshake} label="Who'll be in touch" testid="first-timer-welcome-contact"
          value={d.contact_name ? `${d.contact_name} from our pastoral team` : "Our pastoral team"} />
      </div>
    </div>
  );
};

const Info = ({ icon: Icon, label, value, testid }) => (
  <div className="rounded-xl bg-white/70 px-4 py-3" data-testid={testid}>
    <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-semibold" style={{ color: "#8a6a00" }}><Icon className="h-3.5 w-3.5" /> {label}</div>
    <div className="text-sm font-semibold mt-1" style={{ color: "#3d3000" }}>{value}</div>
  </div>
);
